import { IconProps } from "~/design-system/types";

export function ColoredEmailIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="63"
      height="63"
      viewBox="0 0 63 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="62.9463" height="62.9463" rx="31.4731" fill="#FF667E" />
      <path
        d="M40.1683 26.835L33.6235 32.1569C32.3869 33.1379 30.6472 33.1379 29.4106 32.1569L22.8105 26.835"
        stroke="white"
        strokeWidth="1.96396"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.7045 44.7299C43.1843 44.7423 46.2036 41.0616 46.2036 36.5378V26.4209C46.2036 21.8971 43.1843 18.2164 38.7045 18.2164H24.2432C19.7634 18.2164 16.7441 21.8971 16.7441 26.4209V36.5378C16.7441 41.0616 19.7634 44.7423 24.2432 44.7299H38.7045Z"
        stroke="white"
        strokeWidth="1.96396"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function ColoredPhoneIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="99"
      height="63"
      viewBox="0 0 99 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="17.626"
        width="62.9463"
        height="62.9463"
        rx="31.4731"
        fill="#FF667E"
      />
      <path
        d="M52.5654 17.4799C58.0169 18.0853 62.3239 22.3863 62.9352 27.8378"
        stroke="white"
        strokeWidth="1.96396"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.5654 22.6986C55.1741 23.2053 57.2127 25.2454 57.7208 27.854"
        stroke="white"
        strokeWidth="1.96396"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.6733 32.1689C53.549 38.0431 54.8819 31.2473 58.623 34.9859C62.2297 38.5916 64.3042 39.314 59.733 43.8825C59.1606 44.3425 55.5239 49.8768 42.7432 37.0994C29.9609 24.3203 35.4919 20.6798 35.952 20.1076C40.5327 15.5265 41.2442 17.6115 44.8509 21.2173C48.5904 24.9574 41.7976 26.2947 47.6733 32.1689Z"
        stroke="white"
        strokeWidth="1.96396"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
